import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { Dispatch as ReduxDispatch } from 'redux';
import {
  AddressType,
  AvCheckFormData,
  CmsPageContentIdentifier,
  CmsPageContentType,
  HouseholdConfigurationType,
  ReduxStateType,
  UsageType,
  ResultType,
  AvCheckRequestBody,
  TariffOfferType,
  TariffPositionsType,
  FilterValuesType,
  HeroOfferData,
} from '@/types/av-check';
import { connect } from 'react-redux';
import {
  buildCheckOtherAddressData,
  buildDataForQuestionareModuleClose, buildDataForQuestionareModuleContinue,
  buildErrorData,
  buildWarningData,
  pushToTefDataLayer,
} from '@/services/tracking';
import ApiService from '@/services';
import { actions } from '@/redux/av-check';
import AlertBox from '@/components/av-check/AlertBox/AlertBox';
import { interpolate } from '@/utils';
import DtagFtthAlertBox from '@/components/av-check/AlertBox/DtagFtthAlertBox';

interface FTTHSpecificationModalProps {
  cmsContent: CmsPageContentType,
  address?: AddressType,
  householdConfig?: HouseholdConfigurationType,
  ftthModelRedirectionState: boolean,
  ftthSelectedTariffState:TariffOfferType | undefined,
  ftthmodalTariffPositionsState:TariffPositionsType | undefined,
  setRedirectedFromFtthSelection: Dispatch<SetStateAction<boolean>>,
  isRedirectedFromFtthSelection:boolean,
  ftthExpansionStatus:string,
  serviceUrl:string,
  shopContext: string,
  selectedPack: string,
  selectedRouter: string,
  hardwareOfferName: string,
  setResult: Function,
  setResultError: Function,
  setAddress: Function,
  setHouseholdConfig: Function,
  resetCityList: Function,
  resetStreetList: Function,
  resetTrackingInfo: Function,
  filterValues: FilterValuesType,
  setCurrentContractDuration: Function,
  isDtagGuiEnhancementsToggleEnabledForShop: boolean,
  isDtagGuiEnhancementsToggleEnabledForCci: boolean,
  heroOffer: HeroOfferData | undefined,
}

const FTTHSpecificationModal: React.FC<FTTHSpecificationModalProps> = (
  {
    cmsContent,
    address,
    householdConfig,
    ftthModelRedirectionState,
    ftthSelectedTariffState,
    ftthmodalTariffPositionsState,
    setRedirectedFromFtthSelection,
    isRedirectedFromFtthSelection,
    ftthExpansionStatus,
    serviceUrl,
    shopContext,
    selectedPack,
    selectedRouter,
    hardwareOfferName,
    setResult,
    setResultError,
    setAddress,
    setHouseholdConfig,
    resetCityList,
    resetStreetList,
    resetTrackingInfo,
    setCurrentContractDuration,
    filterValues,
    isDtagGuiEnhancementsToggleEnabledForShop,
    isDtagGuiEnhancementsToggleEnabledForCci,
    heroOffer,
  }: FTTHSpecificationModalProps,
) => {
  if (!address) {
    return null;
  }

  const [buildingPartSelectionName, setBuildingPartSelectionName] = useState('Bitte-waehlen');
  const [buildingPartSelectionId, setBuildingPartSelectionId] = useState('');
  const isDtagGuiEnhancementsToggleEnabled: boolean | undefined =
        isDtagGuiEnhancementsToggleEnabledForCci || isDtagGuiEnhancementsToggleEnabledForShop;
  const [connectionExists, setConnectionExists] = useState<boolean | undefined>(isDtagGuiEnhancementsToggleEnabled ? undefined : true);
  const [showGlasfaserSpecDetails, setShowGlasfaserSpecDetails] = useState(true);
  const [showConnectionStatusError, setShowConnectionStatusError] = useState(false);
  const RESULT_LOADING_MODAL_ID = 'result-loading-modal';
  const DTAG_FTTH_RESULT_LOADING_MODAL_ID = 'dtag-ftth-result-loading-modal';
  const TECHNOLOGY_SELECTION_MODAL_ID = 'modal-technologieauswahl';
  const BUILDING_PART_SELECTION_MODAL_ID = 'modal-technologieauswahlftth';
  const apiService = new ApiService(serviceUrl);
  const [buildingPartValidationError, setBuildingPartValidationError] = useState('');
  const [errorStylingFlag, setErrorStylingFlag] = useState(false);
    const [width, setWidth] = React.useState({
        width: window.innerWidth,
    });

  const validationForConnectionStatusAndBuildingPart = (): boolean => {
    if (isDtagGuiEnhancementsToggleEnabled) {
      let connectionExistsValidation = connectionExists == undefined;
      let buildingPartValidation = address.buildingParts && address.buildingParts.length > 0 && !buildingPartSelectionId;

      if (connectionExistsValidation) {
        setShowConnectionStatusError(true);
      }
      if (buildingPartValidation) {
        setBuildingPartValidationError(cmsContent[CmsPageContentIdentifier.BuildingPartValidationError]);
        setErrorStylingFlag(true);
      }
      return !connectionExistsValidation && !buildingPartValidation;
    } else {
      return true;
    }
  };

  const toggleConnectionExists = (value : boolean) => {
    setConnectionExists(value);
    setShowConnectionStatusError(false);
  };

  const resetSectionStates = () => {
    setBuildingPartSelectionName('');
    setBuildingPartSelectionId('');
    setConnectionExists(isDtagGuiEnhancementsToggleEnabled ? undefined : true);
    setShowGlasfaserSpecDetails(true);
    setBuildingPartSelectionName('Bitte-waehlen');
  };

    const css = ` 
      .continue-btn{
      display: block !important; 
      text-align: right !important;
      }
      .modal-dialog:not(.modal-video).modal-has-footer.modal-scrollable-bottom .modal-content.ftthSelection:after{
        opacity:0 !important; 
     }`;
  function onClick() {
    if (ftthSelectedTariffState !== undefined){
      pushToTefDataLayer(window, buildDataForQuestionareModuleClose(ftthSelectedTariffState!, ftthmodalTariffPositionsState!));
    }
    resetSectionStates();
  }
  const closeButton = () => (
        <div>
            <button className="close" type="button" data-dismiss="modal" data-tracking-action="close" onClick={onClick}>
                <span>&#xD7;</span>
            </button>
        </div>
  );

  const glassfaserModalHeader = () => (
        <div>
            <h3 className="modal-title"
                dangerouslySetInnerHTML={{ __html: cmsContent[CmsPageContentIdentifier.GlassfaserModalHeader] }}/>
        </div>
  );

  const buildingPartSelectionHandler = (event: React.ChangeEvent<HTMLSelectElement>)  => {
    const selectedOption = event.currentTarget.selectedOptions.length > 0 ? event.currentTarget.selectedOptions[0] : null;
    if (selectedOption) {
      setBuildingPartSelectionName(selectedOption.value);
      setBuildingPartSelectionId(selectedOption.id);
      setBuildingPartValidationError('');
      setErrorStylingFlag(false);

      const matchedBuildingPart = address.buildingParts.filter(value => value.buildingPartId == selectedOption.id);
      setShowGlasfaserSpecDetails(!(matchedBuildingPart.length == 1 &&
          (matchedBuildingPart[0].expansionStatus == 'notPlanned' || matchedBuildingPart[0].expansionStatus == 'areaPlanned')));
    }
  };

  const buildingPartSelection = () => {
    const buildingPartInput = useRef(null);
    useEffect(() => {
      if (buildingPartInput != null && buildingPartInput.current != null) {
        // @ts-ignore
        buildingPartInput.current.focus();
      }
    });

    return (
            <>
                { (address && address.buildingParts.length > 0 ) &&
                    <>
                        <div style={{ marginBottom : '20px' }}
                            dangerouslySetInnerHTML={{ __html: cmsContent[CmsPageContentIdentifier.GlassfaserModalBuildingPartId] }}/>
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-lg-5 col-md-5">
                            <span className={`'nice-select' ${errorStylingFlag ? 'input size-xs has-error' : ''}`}>
                              <select
                                      ref={buildingPartInput}
                                      className="form-control"
                                      name="buildingPartSelection"
                                      defaultValue="Bitte-waehlen"
                                      value={buildingPartSelectionName}
                                      onChange={buildingPartSelectionHandler}>
                                  <option value="Bitte-waehlen" >Bitte wählen</option>
                                  {
                                      address &&
                                      address.buildingParts.map(function (item) {
                                        return <option id={item.buildingPartId}>{item.buildingPartName}</option>;
                                      })
                                  }
                              </select>
                            </span>
                            </div>
                        </div>
                        {
                            <div className="input size-xs has-error">
                                <div className="help-block" dangerouslySetInnerHTML={{ __html:  buildingPartValidationError }}/>
                            </div>
                        }
                        <hr/>
                    </>
                }

            </>
    );
  };

  const glasfaserAdditionalDetails = () => (
        <>
            <div className="margin-top-lg"
                 dangerouslySetInnerHTML={{ __html: cmsContent[CmsPageContentIdentifier.GlassfaserModalDoseIllustrationText] }}/>
        </>
  );

  const closeBuildingPartSelectionModel = () => {
    resetSectionStates();
    ($(`#${BUILDING_PART_SELECTION_MODAL_ID}`) as any).modal('hide');
  };

  const dtagEnhancementElement = () => (
      <>
          <div
              className="row" style={{ margin : '10px 0px' }}>
              <div
              dangerouslySetInnerHTML={{ __html: cmsContent[CmsPageContentIdentifier.GlassfaserModalFtthEnhancementAdditionalText] }}/>
          </div>
          <div className="row" style={{ margin : '15px -10px', display : showConnectionStatusError ? 'block' : 'none' }}>
              <div className="col-xs-12 col-sm-12 col-lg-7 col-md-7">
                  <DtagFtthAlertBox
                      type="danger"
                      contentIdentifier={CmsPageContentIdentifier.GlassfaserModalRadioButtonValdation}
                  />
              </div>
          </div>
          <div className="row" style={{ margin : '10px 0px' }}>
              <div className="radio col-sm-12 col-lg-12 col-md-12" onChange={() => toggleConnectionExists(true)}>
                  <input type="radio" name="isExistingConnection" id="ja_ExistingConnection"
                         checked={connectionExists != undefined ? connectionExists : false}
                  />
                  <label htmlFor="ja_ExistingConnection"
                         dangerouslySetInnerHTML={{ __html: cmsContent[CmsPageContentIdentifier.GlassfaserModalRadioButtonTextYes] }}/>
              </div>
          </div>
          <div className="row" style={{ margin : '10px 0px' }} >
              <div className="radio col-sm-12 col-lg-12 col-md-12" onChange={() => toggleConnectionExists(false)}>
                  <input type="radio" name="isExistingConnection" id="Nein_ExistingConnection"
                         checked={connectionExists != undefined ? !connectionExists : false}/>
                  <label htmlFor="Nein_ExistingConnection"
                         dangerouslySetInnerHTML={{ __html: cmsContent[CmsPageContentIdentifier.GlassfaserModalRadioButtonTextNo] }}/>
              </div>
              <div className="continue-btn">
                  {continueButton()}
              </div>
          </div>
      </>
  );

  const dtagExistingConnectionElement = () =>
    (
        <>
            <div className='row'>
                <div className="radio col-sm-4" onChange={() => toggleConnectionExists(true)}>
                    <input type="radio" name="isExistingConnection" id="ja_ExistingConnection"
                           checked={connectionExists}/>
                    <label htmlFor="ja_ExistingConnection">Ja</label>
                </div>
                <div className="radio col-sm-4" style={{ marginTop: '10px', marginBottom: '20px' }}
                     onChange={() => toggleConnectionExists(false)}>
                    <input type="radio" name="isExistingConnection" id="Nein_ExistingConnection"
                           checked={!connectionExists}/>
                    <label htmlFor="Nein_ExistingConnection"> Nein/Ich weiB nicht</label>
                </div>
            </div>
            <div
                dangerouslySetInnerHTML={{ __html: cmsContent[CmsPageContentIdentifier.GlassfaserModalFtthAdditionalText] }}/>
        </>
    );

  const glasfaserSpecDetails = () => (
        (ftthExpansionStatus === 'ready' || ftthExpansionStatus === 'prepared') ? (
            <>
                <div
                    dangerouslySetInnerHTML={{ __html: cmsContent[CmsPageContentIdentifier.GlassfaserModalAvailabilityRadioText] }}/>
                {isDtagGuiEnhancementsToggleEnabled ? dtagEnhancementElement() : dtagExistingConnectionElement()}
                {glasfaserAdditionalDetails()}
            </>
        ) : null
  );

  const openLoadingModal = (open: boolean) => {
    isDtagGuiEnhancementsToggleEnabled
      ? ($(`#${DTAG_FTTH_RESULT_LOADING_MODAL_ID}`) as any).modal(open ? 'show' : 'hide')
      : ($(`#${RESULT_LOADING_MODAL_ID}`) as any).modal(open ? 'show' : 'hide');
  };

  const openTechnologySelectionModel = () => {
    ($(`#${TECHNOLOGY_SELECTION_MODAL_ID}`) as any).modal('show');
  };

  const disableContinueButton = () => {
    return isDtagGuiEnhancementsToggleEnabled ? false :  address.buildingParts && address.buildingParts.length > 0 && !buildingPartSelectionId ;
  };
  // here separate call for av-check with building part data has been used
  // due to in case existing call of av-check we have to make it parameterised and
  // there will be much condition for updating sates and maintaining states
  const onAvCheckWithBuildingParts = () => {
    if (validationForConnectionStatusAndBuildingPart()) {
      const waringMessage =
              interpolate(cmsContent[CmsPageContentIdentifier.GlassfaserModalAertMessage], { ...address });
      if (!showGlasfaserSpecDetails) {
        closeBuildingPartSelectionModel();
        if (ftthSelectedTariffState !== undefined) {
          pushToTefDataLayer(window, buildDataForQuestionareModuleContinue(ftthSelectedTariffState!,
            ftthmodalTariffPositionsState!,
            buildingPartSelectionName,
            connectionExists ? 'ja' : 'nein', 'warning:' + waringMessage));
        }
      } else if (!disableContinueButton()) {
        closeBuildingPartSelectionModel();
        if (ftthSelectedTariffState !== undefined) {
          pushToTefDataLayer(window, buildDataForQuestionareModuleContinue(ftthSelectedTariffState!,
            ftthmodalTariffPositionsState!,
            buildingPartSelectionName,
            connectionExists ? 'ja' : 'nein', 'success'));
        }
        setRedirectedFromFtthSelection(true);

        var dataForAvcheck: AvCheckFormData = {
          zipCode: address.zipCode,
          city: address.city,
          houseNumber: address.houseNumber,
          street: address.street,
          corrected: address.corrected,
          numberOfPersons: householdConfig?.personInHousehold ? householdConfig.personInHousehold.toString() : '',
          usageTypeOnlineGaming: householdConfig?.personInHousehold ? householdConfig.usageTypes.includes(UsageType.GAMING) : false,
          usageTypeVideoStreaming: householdConfig?.personInHousehold ? householdConfig.usageTypes.includes(UsageType.STREAMING) : false,
          usageTypeHomeOffice: householdConfig?.personInHousehold ? householdConfig.usageTypes.includes(UsageType.HOME_OFFICE) : false,
          buildingParts: {
            buildingPartId: buildingPartSelectionId,
            buildingPartName: buildingPartSelectionName,
            expansionPeriodEnd: '',
            expansionPeriodStart: '',
            expansionStatus: '',
          },
          isFiberExtensionAvailable: connectionExists,
          buildingPartId: buildingPartSelectionId,
        };

        setResultError(false);
        openLoadingModal(true);

        let avCheckPending = true;
        let avCheckResult: ResultType;
        let resultError = false;

        const startTimeout = (timeout: number) => {
          setTimeout(() => {
            if (!avCheckPending) {
              if (resultError) {
                setResultError(resultError);
              } else {
                avCheckResult.currentContractDuration = filterValues.CONTRACT_DURATION;
                setResult(avCheckResult);
                setCurrentContractDuration(filterValues.CONTRACT_DURATION);
                if (avCheckResult.address) {
                  setAddress(avCheckResult.address);
                }
                if (avCheckResult.householdConfiguration) {
                  setHouseholdConfig(avCheckResult.householdConfiguration);
                }
              }
              openLoadingModal(false);
              openTechnologySelectionModel();
            } else {
              // in the case that av check takes longer than 3s
              // timeout will be increased by 1s until the av check is completed
              startTimeout(1000);
            }
          }, timeout);
        };

        const avCheckRequestBody = new AvCheckRequestBody(dataForAvcheck, heroOffer);

        // 3s as initial timeout is needed to make sure the loading modal will be shown
        // at least 5s whenever the av result is returned
        startTimeout(3000);

          if(ftthExpansionStatus === 'prepared' || ftthExpansionStatus === 'ready') {
              apiService.checkAvailability(
                  avCheckRequestBody,
                  shopContext,
                  selectedPack,
                  selectedRouter,
                  hardwareOfferName,
              )
                  .then((resultResponse) => {
                      avCheckPending = false;
                      avCheckResult = resultResponse as any;
                      if (avCheckResult.address) {
                          const resultAddress = `${avCheckResult.address.zipCode} ${avCheckResult.address.city}`;
                          if (avCheckResult.tariffOffers.length === 0) {
                              pushToTefDataLayer(window, buildWarningData('no offers found!', resultAddress));
                          }
                      } else {
                          pushToTefDataLayer(window, buildWarningData('no address found!', `${dataForAvcheck.zipCode} ${dataForAvcheck.city}`));
                      }
                  })
                  .catch((err) => {
                      avCheckPending = false;
                      resultError = true;
                      console.error('Unable to check availability:', err);
                      pushToTefDataLayer(window, buildErrorData(err.message, avCheckRequestBody));
                  });
          }
      } else {
        return false;
      }
    }
  };

  const continueButton = () => (
        <a className={`btn ${ disableContinueButton() ? 'disabled' : ''}`}
           type="button"
           onClick={onAvCheckWithBuildingParts}
        >
            {!showGlasfaserSpecDetails ? 'Zurück Zu den Tarifen' : 'Weiter mit Glasfaser' }
        </a>
  );

    return (
        <>
            {ftthExpansionStatus === 'ready' || ftthExpansionStatus === 'prepared' ? (
                <>
                    <style>{css}</style>
                    <div className="modal" id="modal-technologieauswahlftth" tabIndex={-1} role="dialog">
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content ftthSelection">
                                <div className="modal-header">
                                    {closeButton()}
                                    <article className="article">{glassfaserModalHeader()}</article>
                                </div>
                                <div className="modal-body">
                                    <article className="article">
                                        {buildingPartSelection()}
                                        {glasfaserSpecDetails()}
                                    </article>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                    <div className="modal-body">
                        <article className="article">
                            {buildingPartSelection()}
                            {glasfaserSpecDetails()}
                        </article>
                    </div>
            )}
        </>
    );
};

const mapStateToProps = (state: ReduxStateType) => ({
  cmsContent: state.cmsContent,
  address: state.result?.address,
  householdConfig: state.result?.householdConfiguration,
  filterValues:state.filterValues,
  heroOffer: state.meta?.heroOfferData,
});

const mapDispatchToProps = (dispatch: ReduxDispatch) => ({
  setAddress: (address: AddressType) => dispatch(actions.setAddress(address)),
  setHouseholdConfig: (householdConfig: HouseholdConfigurationType) => dispatch(actions.setHouseholdConfig(householdConfig)),
  setResult: (result: ResultType) => dispatch(actions.setResult(result)),
  setResultError: (isError: boolean) => dispatch(actions.setResultError(isError)),
  resetCityList: () => dispatch(actions.setCityList(undefined)),
  resetStreetList: () => dispatch(actions.setStreetList(undefined)),
  resetTrackingInfo: () => dispatch(actions.setTrackingInfo({ isFirstSliderView: true, sliderTariffPositions: {} })),
  setCurrentContractDuration:(contractDuration: number) => dispatch(actions.setCurrentContractDuration(contractDuration)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FTTHSpecificationModal);
